export default {
  SET_PAIR_COIN_SCALES: (state, scalesList) => {
    state.pairCoinScales = scalesList;
  },
};
